import { Transition } from "@headlessui/react";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { ImCross } from "react-icons/im";

import { checkUsernameAvailabilityInLocal, getDaffiLoginToken, reinstallFromDaffiAccount } from "actions/auth";
import { getUserByToken } from "actions/profile";
import { fetchingDataFromApi } from "actions/loaders";

import EmailOTPVerification from "views/components/auth/verification/EmailOTPVerification";
import GeneratePin from "views/components/auth/GeneratePin";

const ReinstallAndLogin = ({ navigatePage, loginType, username }) => {
	const dispatch = useDispatch();

	const [formData, setFormData] = useState(null);
	const [showPassword, setShowPassword] = useState(null);
	const [userID, setUserID] = useState(null);
	const [userProfile, setUserProfile] = useState(null);
	const [isUsernameAvailable, setIsUsernameAvailable] = useState(true);
	const [isUserVerified, setIsUserVerified] = useState(true);

	const fetchingDataFromApi = useSelector((state) => state.FetchingDataFromApi);
	const deviceInfo = useSelector((state) => state.DeviceInfo);

	useEffect(() => {
		if (userProfile?.password) {
			dispatch(reinstallFromDaffiAccount(userProfile, navigatePage));
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userProfile]);

	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value,
		});
	};

	const DaffiUserLogin = () => {
		dispatch(fetchingDataFromApi(true));

		getDaffiLoginToken({
			username: formData?.username,
			password: formData?.password,
			"device-info": deviceInfo,
		}).then(async (accessToken) => {
			if (accessToken)
				await getUserByToken(accessToken).then((user) => {
					if (user?._id) setUserID(user._id);
					if (!user?.["verified-status"]) setIsUserVerified(false);
					setUserProfile({ ...user, "access-token": accessToken, loginType: loginType });
				});
		});

		dispatch(fetchingDataFromApi(false));
	};

	return (
		loginType && (
			<Transition
				as={Fragment}
				appear={true}
				show={true}
				enter="transition-opacity duration-500"
				enterFrom="opacity-0"
				enterTo="opacity-100"
				leave="transition-opacity duration-250"
				leaveFrom="opacity-100"
				leaveTo="opacity-0"
			>
				{username ? (
					<div className="w-full text-center text-sm text-gray-600 space-y-4">
						{userProfile ? (
							!isUserVerified ? (
								<div className="border px-5 py-5 rounded-xl">
									<EmailOTPVerification
										userID={userID}
										formData={userProfile}
										registrationType={loginType}
										navigatePage={navigatePage}
									/>
								</div>
							) : (
								<GeneratePin formData={userProfile} setFormData={setUserProfile} />
							)
						) : (
							<div className="flex-col w-full space-y-3">
								<div className="flex-col w-full space-y-4">
									<div className="w-full flex-col items-center justify-start">
										<p className={`flex font-medium text-dark-blue`}>Username</p>
										<input
											className="rounded-lg border border-dark-blue w-full px-3 py-2 focus:outline-none"
											name="username"
											placeholder="Username"
											type="text"
											required
											onChange={async (e) => {
												handleChange(e);
												setIsUsernameAvailable(
													await checkUsernameAvailabilityInLocal(e.target.value, loginType)
												);
											}}
										/>
									</div>

									{!isUsernameAvailable && formData?.username?.length > 1 && (
										<div className="flex items-center space-x-2">
											<ImCross className="text-sm text-candy-red" />
											<p className="text-sm text-candy-red">User already exists</p>
										</div>
									)}

									<div className="flex-col items-center justify-start">
										<p htmlFor="password" className={`flex font-medium text-dark-blue`}>
											Password
										</p>
										<label
											htmlFor="password"
											className="relative text-gray-400 focus-within:text-gray-600 block"
										>
											{showPassword ? (
												<AiFillEyeInvisible
													className="absolute text-lg cursor-pointer top-1/2 transform -translate-y-1/2 right-3"
													onClick={() => setShowPassword(false)}
												/>
											) : (
												<AiFillEye
													className="absolute text-lg cursor-pointer top-1/2 transform -translate-y-1/2 right-3"
													onClick={() => setShowPassword(true)}
												/>
											)}
											<input
												name="password"
												placeholder="Password"
												type={showPassword ? "text" : "password"}
												required
												onChange={(e) => handleChange(e)}
												className="rounded-lg border border-dark-blue w-full px-3 py-2 focus:outline-none"
											/>
										</label>
									</div>
									<div className="flex items-center justify-center">
										<p className={`flex text-sm font-medium text-dark-blue`}>Forgot your password?</p>
									</div>
								</div>

								<div className="flex w-full items-center justify-center">
									{fetchingDataFromApi ? (
										<img className="animate-spin mx-auto h-5 w-auto" src="/media/logo.png" alt="img" />
									) : (
										<button
											type="submit"
											onClick={() => DaffiUserLogin()}
											disabled={
												formData?.username && formData?.password && isUsernameAvailable ? false : true
											}
											className="bg-dark-blue smooth hover:text-black hover-border-gray-900 text-gray-100 py-3 px-8 mt-5 border border-transparent rounded-3xl disabled:bg-gray-100 disabled:text-gray-400"
										>
											{loginType === "daffi" ? "Login" : "Access local"}
										</button>
									)}
								</div>
							</div>
						)}
					</div>
				) : (
					<></>
				)}
			</Transition>
		)
	);
};

export default ReinstallAndLogin;
